import * as React from "react";
import { useEffect, useState } from "react";
import { Grid, Box } from "@mui/material";
import { themes } from "../../../themes/themes";

interface IProps {
  onPrint?: any;
  onDownload?: any;
  onView?: any;
}
const GetPayHistoryActionBox: React.FC<IProps> = ({
  onDownload,
  onPrint,
  onView,
}) => {
  return (
    <div>
      <Grid container spacing={1}>
        {/* <Grid item xs={4}>
          <Box
            style={{
              border: "1px solid #E6E8EF",
              color: themes.darkBlue,
              width: "1.8125em",
              height: "1.8125em",
              alignItems: "center",
              justifyContent: "center",
              display: "flex",
              borderRadius: "0.375em",
              cursor: "pointer",
            }}
            onClick={onPrint}
          >
            <i className="las la-print"></i>
          </Box>
        </Grid> */}
        <Grid item xs={6}>
          {/* <Box
            style={{
              border: "1px solid #E6E8EF",
              color: themes.darkBlue,
              width: "1.8125em",
              height: "1.8125em",
              alignItems: "center",
              justifyContent: "center",
              display: "flex",
              borderRadius: "0.375em",
              cursor: "pointer",
            }}
            onClick={onDownload}
          >
            <i className="las la-download"></i>
          </Box> */}
        </Grid>
        <Grid item xs={6}>
          <Box
            style={{
              border: "1px solid #E6E8EF",
              color: themes.primary,
              width: "1.8125em",
              height: "1.8125em",
              alignItems: "center",
              justifyContent: "center",
              display: "flex",
              borderRadius: "0.375em",
              cursor: "pointer",
            }}
            onClick={onView}
          >
            <i className="las la-eye"></i>
          </Box>
        </Grid>
      </Grid>
    </div>
  );
};
export default GetPayHistoryActionBox;
